import * as React from "react"
import { useState, useEffect } from "react"
import { Alert, Box, Tab, Tabs, Button, Grid } from "@mui/material"
import { useAuth } from "../../components/Auth"
import { loginUrl } from "../../utils/authApi"
import AddImage from "../components/AddImage"
import KeypointTab from "../../components/home/KeypointTab"
import EditImage from "../components/EditImage"
import HoldMapping from "../components/HoldMapping"
import PodPanel from "../components/PodPanel"
import ScenesPanel from "../components/ScenesPanel"
import UsersPanel from "../components/UsersPanel"

export default function FindClimb() {
  const [value, setValue] = useState(0)
  const { user, loading } = useAuth()

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  // Admin-only page: the backend enforces this on every /api/admin endpoint;
  // this gate just keeps the UI honest.
  if (loading) return null
  if (!user) {
    return (
      <Alert severity="warning" sx={{ mt: 2 }}>
        Admins only — <a href={loginUrl()}>sign in</a> first.
      </Alert>
    )
  }
  if (!user.is_admin) {
    return (
      <Alert severity="warning" sx={{ mt: 2 }}>
        Admins only.
      </Alert>
    )
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Add Image" />
          <Tab label="Edit Image" />
          <Tab label="Keypoint" />
          <Tab label="Hold Mapping" />
          <Tab label="GPU Worker" />
          <Tab label="Scenes" />
          <Tab label="Users" />
        </Tabs>
      </Box>
      <div style={{ display: value === 0 ? "block" : "none" }}>
        <AddImage />
      </div>
      <div style={{ display: value === 1 ? "block" : "none" }}>
        <EditImage />
      </div>
      <div style={{ display: value === 2 ? "block" : "none" }}>
        <KeypointTab />
      </div>
      <div style={{ display: value === 3 ? "block" : "none" }}>
        <HoldMapping />
      </div>
      <div style={{ display: value === 4 ? "block" : "none" }}>
        <PodPanel />
      </div>
      <div style={{ display: value === 5 ? "block" : "none" }}>
        <ScenesPanel />
      </div>
      <div style={{ display: value === 6 ? "block" : "none" }}>
        <UsersPanel />
      </div>
    </Box>
  )
}
